/*
    Business Logic for member form with questionnaire option selected
*/
define('shared/initializer/form/adapters/mixins/MemberCreationQuestionnaireBeforeCreatable',[
    'shared/lib/RSVP',
    'shared/remote/member/get',
    'shared/initializer/form/constants'
], function (
    RSVP,
    getMemberInfo,
    constants
) {
    'use strict';

    function disableRedeem() {
        var me = this;
        me.options.memberCreatable = me.options.memberCreatable || {};
        me.options.memberCreatable.disablePageOnLoadRedeem = true;
    }

    function Ctor() { 
    }

    Ctor.prototype.doPageLoad = function() {
        var me = this;
        return RSVP.resolve()
            .then(function(){
                return getMemberInfo();
            })
            .then(function(memberInfo){
                if (
                    memberInfo == null || 
                    memberInfo.StudentType === constants.StudentType.CurrentStudent || 
                    memberInfo.StudentType === constants.StudentType.LapsedStudent
                ) {
                    return disableRedeem.apply(me);
                }
                else {
                    return RSVP.resolve();
                }
            }, function(){
                return disableRedeem.apply(me);
            });
    };

    return Ctor;
});
